// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios';
// import VCharts from 'v-charts'
import VeRing from 'v-charts/lib/ring.common'
import 'echarts/lib/component/graphic'


Vue.use(ElementUI);
Vue.prototype.$http = axios;
Vue.prototype.rootPath = getRootPath();
// Vue.use(VCharts)
Vue.component(VeRing.name, VeRing)

function getRootPath() {
  var curWwwPath = window.document.location.href;
  var pathName = window.document.location.pathname;
  if (pathName && pathName != "" && curWwwPath.lastIndexOf(pathName) > 0) {
      var pos = curWwwPath.lastIndexOf(pathName);
      var localhostPath = curWwwPath.substring(0, pos);
      // var pathNameArray = pathName.split("/");
      // if (pathNameArray.length > 1) {
      //     localhostPath += pathNameArray[0] + "/" + pathNameArray[1];
          //localhostPath += pathNameArray[0] + "/" + pathNameArray[1] + "/" + pathNameArray[2];
      // }
      return localhostPath;
  } else {
      return curWwwPath;
  }
}

window.Promise = Promise;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js